const ApiURL = {
  _signup: "v1/auth/signup",
  _signupVerify: "v1/auth/signup/verify",
  _directorySync: "v1/auth/add-idp",
  _login: "v1/auth/login",
  _logout: "v1/auth/logout",
  _loginVerify: "v1/auth/login/verify",
  _refreshOtp: "v1/auth/signup/send-otp",
  _accessToken: "v1/auth/access-token-login",
  _refreshToken: "v1/auth/refresh-token",
  _addUser: "v1/auth/internal/add-user",
  
  _dashboard: "v1/external-admin-dashboard/",
  _district: "v1/districts",
  _districtUploadLogo: "v1/districts/upload-logo",
  _campus: "v1/campuses",
  _building: "v1/buildings",
  _tag: "v1/tags",
  _bulkTag: "v1/tags/bulk-tag",
  _tagIcon: "v1/tags/icons",
  _user: "v1/users",
  _userDistrict: "/v1/users/district",
  _userDeleteInvite: "/v1/users/invite",
  _userUpdateRole: "v1/users/update-role",
  _admin: "/v1/users/admins",
  _userOtherDetail: "v1/users/update-profile",
  _userUploadProfilePicture: "v1/users/upload-profile-picture",
  _updateUserDetail: "/v1/users/update-user-detail",
  _userInvite: "v1/users/invite",
  _userReInvite: "v1/users/invite/resend",
  
  _uploadChunk: "/file-sharing/files/large-upload",
  _incident: "/v1/incidents",
  _ongoingincident: "/v1/incidents/ongoing",
  _startIncident: "/v1/incidents/start",
  _endIncident: "/v1/incidents/end",
  _cancelIncident: "/v1/incidents/cancel",
  
  _netientHost: "/v1/netint/hosts",

  _role: '/v1/roles/',
  _permissions: '/v1/permissions',
  _updatePermissions: '/v1/permissions/user-permissions',

  _domain: "/v1/domains",
  _domainUser: "/v1/users/domain",
  _domainUserRejected: "/v1/users/domain/rejected",
  };

export default ApiURL;
